import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useProjectTasksQuery } from 'queries/task';
import { selectTasksByProjectIdSelector } from '../selectors';
/**
 *
 * @deprecated Use `TasksStore.ofId`
 */ export const useTasksByIds = (projectId, taskIds)=>{
    const memoized = useMemo(selectTasksByProjectIdSelector, []);
    return useSelector((state)=>memoized(state, taskIds));
};
export const useTasksByIdsFromRQ = (projectId, taskIds)=>{
    const { data: tasks, isLoading, ...query } = useProjectTasksQuery(projectId);
    const memoized = useMemo(()=>{
        var _tasks_filter_sort;
        return tasks ? tasks === null || tasks === void 0 ? void 0 : (_tasks_filter_sort = tasks.filter((e)=>{
            var _taskIds_includes;
            return taskIds === null || taskIds === void 0 ? void 0 : (_taskIds_includes = taskIds.includes) === null || _taskIds_includes === void 0 ? void 0 : _taskIds_includes.call(taskIds, e === null || e === void 0 ? void 0 : e.taskId);
        }).sort((a, b)=>taskIds.indexOf(a === null || a === void 0 ? void 0 : a.taskId) - taskIds.indexOf(b === null || b === void 0 ? void 0 : b.taskId))) === null || _tasks_filter_sort === void 0 ? void 0 : _tasks_filter_sort.map((d)=>{
            var _d_project, _d_subTasks;
            return {
                ...d,
                project: d === null || d === void 0 ? void 0 : (_d_project = d.project) === null || _d_project === void 0 ? void 0 : _d_project.projectId,
                subTasks: d === null || d === void 0 ? void 0 : (_d_subTasks = d.subTasks) === null || _d_subTasks === void 0 ? void 0 : _d_subTasks.map((e)=>e === null || e === void 0 ? void 0 : e.taskId)
            };
        }) : [];
    }, [
        taskIds,
        tasks
    ]);
    return {
        tasks: memoized,
        isLoading,
        data: memoized,
        ...query
    };
};
